var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({el: 'body', duration: 0}),expression:"{el: 'body', duration: 0}"}],attrs:{"id":"top"}},[_c('button',{staticClass:"topbtn__btn"},[_vm._v(_vm._s(_vm.$t('generic.top')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7817dd02","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/TopBtn.vue
// module id = 429
// module chunks = 1